import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "ion-text-center" }
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_datetime_button = _resolveComponent("ion-datetime-button")!
  const _component_ion_datetime = _resolveComponent("ion-datetime")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showHeader)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, { slot: "start" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_button, {
                      slot: "icon-only",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_title, { style: {"padding-left":"0"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.lesson.lessonShortName || _ctx.lesson.lessonDisplayName), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.userSchoolAB4Intakes.length > 0)
                  ? (_openBlock(), _createBlock(_component_ion_select, {
                      key: 0,
                      fill: "outline",
                      interface: "popover",
                      slot: "end",
                      style: {"min-width":"130px"},
                      modelValue: _ctx.selectedIntakeId,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedIntakeId) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSchoolAB4Intakes, (intake) => {
                          return (_openBlock(), _createBlock(_component_ion_select_option, {
                            key: intake.id,
                            value: intake.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(intake.academicYear), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFilteredSessions(), (ev) => {
      return (_openBlock(), _createBlock(_component_ion_card, {
        key: ev.id,
        disabled: _ctx.isPastEvent(ev)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("On")
                    ])),
                    _: 1,
                    __: [3]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_datetime_button, {
                        datetime: `${ev.id}_date`,
                        style: {"font-size":"14px","justify-content":"left"}
                      }, null, 8, ["datetime"]),
                      _createVNode(_component_ion_modal, {
                        class: "datetime-modal",
                        "keep-contents-mounted": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_datetime, {
                            presentation: "date",
                            id: `${ev.id}_date`,
                            modelValue: ev.date,
                            "onUpdate:modelValue": ($event: any) => ((ev.date) = $event),
                            showDefaultButtons: true
                          }, null, 8, ["id", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[4] || (_cache[4] = [
                      _createTextVNode("Venue")
                    ])),
                    _: 1,
                    __: [4]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        "label-placement": "fixed",
                        modelValue: ev.venue,
                        "onUpdate:modelValue": ($event: any) => ((ev.venue) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  (ev.schoolAddrGmapEmbedLink && !_ctx.isPastEvent(ev))
                    ? (_openBlock(), _createElementBlock("iframe", {
                        key: 0,
                        src: ev.schoolAddrGmapEmbedLink,
                        class: "responsive-embed",
                        width: "100%",
                        height: "250",
                        style: {"border":"0"},
                        allowfullscreen: "",
                        loading: "lazy",
                        referrerpolicy: "no-referrer-when-downgrade"
                      }, null, 8, _hoisted_1))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("# students")
                    ])),
                    _: 1,
                    __: [5]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        type: "number",
                        inputmode: "numeric",
                        modelValue: ev.numOfStudents,
                        "onUpdate:modelValue": ($event: any) => ((ev.numOfStudents) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                      _createTextVNode("Form(s)")
                    ])),
                    _: 1,
                    __: [6]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        modelValue: ev.studentForms,
                        "onUpdate:modelValue": ($event: any) => ((ev.studentForms) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("Class(s)")
                    ])),
                    _: 1,
                    __: [7]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        modelValue: ev.classes,
                        "onUpdate:modelValue": ($event: any) => ((ev.classes) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[8] || (_cache[8] = [
                      _createTextVNode("Arrival & standby")
                    ])),
                    _: 1,
                    __: [8]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        type: "time",
                        modelValue: ev.arrivalTime,
                        "onUpdate:modelValue": ($event: any) => ((ev.arrivalTime) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("Venue preparation")
                    ])),
                    _: 1,
                    __: [9]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        type: "time",
                        modelValue: ev.roomAvailableTime,
                        "onUpdate:modelValue": ($event: any) => ((ev.roomAvailableTime) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("Class start")
                    ])),
                    _: 1,
                    __: [10]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        type: "time",
                        modelValue: ev.startTime,
                        "onUpdate:modelValue": ($event: any) => ((ev.startTime) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "3"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("Class end")
                    ])),
                    _: 1,
                    __: [11]
                  }),
                  _createVNode(_component_ion_col, {
                    class: "ion-text-left",
                    size: "9"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        mode: "ios",
                        type: "time",
                        modelValue: ev.endTime,
                        "onUpdate:modelValue": ($event: any) => ((ev.endTime) = $event),
                        fill: "outline"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      (_ctx.suggestedDuration)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Suggested duration: " + _toDisplayString(_ctx.suggestedDuration) + "+ mins", 1))
                        : _createCommentVNode("", true),
                      _cache[12] || (_cache[12] = _createElementVNode("p", null, "If availability allows we are happy to arrive 45 min before class start to ensure seating is correct as this critically determines the learners' experience.", -1))
                    ]),
                    _: 1,
                    __: [12]
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_ion_button, {
            color: "success",
            expand: "block",
            onClick: ($event: any) => (_ctx.saveUpdatedSessions([ev]))
          }, {
            default: _withCtx(() => _cache[13] || (_cache[13] = [
              _createTextVNode(" Save ")
            ])),
            _: 2,
            __: [13]
          }, 1032, ["onClick"])
        ]),
        _: 2
      }, 1032, ["disabled"]))
    }), 128)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        style: {"width":"100%"},
        src: _ctx.getSeatingPlanImgLink(),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openImageModal(_ctx.getSeatingPlanImgLink())))
      }, null, 8, _hoisted_4)
    ])
  ], 64))
}